import { keys } from 'lodash'
import { ReactElement, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { paymentMethodMessages } from 'features/Bookings/components/PaymentMethod/messages'
import { sanitizePrice } from 'utils/math'
import { canReadDrawerBookings } from 'features/Users/utils'
import { safeFormatMessage } from 'utils/intl'
import { groupBy } from 'lodash'
import { useLogin } from 'features/Login/hooks'
import { GTPaymentStatus } from 'gql/types.generated'

const BookingsWrapper = styled.div<TSFixMe>`
  margin-top: 10px;
`

export const DrawerBookings = ({ bookings = [], expectedAmount }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [isModalOpen, setModalOpen] = useState(false)
  const login = useLogin()
  const confirmedBookings = bookings.filter((booking: TSFixMe): TSFixMe => !booking.isCancelled)

  return (
    <div>
      <div>
        <FormattedPrice value={expectedAmount} />
      </div>
      {canReadDrawerBookings(login.accessToken.policies) && (
        <BookingsWrapper>
          {bookings.length > 0 ? (
            <div>
              <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{confirmedBookings.length}</StyledLink>
            </div>
          ) : (
            0
          )}
        </BookingsWrapper>
      )}
      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="drawer.bookings.title" defaultMessage="Bookings" />
            </Heading.H5>
          </Modal.Header>
          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="dictionary.id" defaultMessage="Id" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.buyer" defaultMessage="Buyer" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.amount" defaultMessage="Amount" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.paymentMethod" defaultMessage="Payment method" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.last4" defaultMessage="Last 4" />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {confirmedBookings.map((booking: TSFixMe): ReactElement => {
                    const paidOrRefundedPayments = booking.payments.filter(
                      (payment: TSFixMe) => payment.status === GTPaymentStatus.Paid
                    )
                    const paymentsGroupedByPaymentMethod = groupBy(paidOrRefundedPayments, 'method')

                    return (
                      <>
                        {keys(paymentsGroupedByPaymentMethod).map((paymentMethod, index): TSFixMe => {
                          const payments = paymentsGroupedByPaymentMethod[paymentMethod]
                          const paidAmount = payments.reduce((result, payment): TSFixMe => {
                            return result + payment.amount
                          }, 0)

                          const successPayment = payments.find(
                            (payment): TSFixMe => payment.status === GTPaymentStatus.Paid
                          )

                          return (
                            <Tr key={index}>
                              <Td>
                                <CopyToClipboardWrapper>
                                  <div>{booking.id.substring(0, 8)}</div>

                                  <CopyToClipboard str={booking.id} />
                                </CopyToClipboardWrapper>
                              </Td>
                              <Td>
                                {booking.buyer.firstName} {booking.buyer.lastName}
                              </Td>
                              <Td>
                                <FormattedPrice value={sanitizePrice(paidAmount)} />
                              </Td>
                              <Td>
                                {safeFormatMessage({ intl, messages: paymentMethodMessages, key: paymentMethod })}
                              </Td>
                              <Td>{successPayment.last4}</Td>
                            </Tr>
                          )
                        })}
                      </>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
